import React from 'react'
import XMLViewer from 'react-xml-viewer'

const XmlViewer = ({ xml }) => (<div className='m-2'><XMLViewer xml={xml} /></div>)

export default XmlViewer;